import { Controller } from 'stimulus';
import Chart from 'chart.js/auto';
import { t } from '../../javascript/lib/i18n';
import { currentTheme } from '../chart_controller/plugins/background_color_plugin';

const COLOR_BLACK = '#000';
const COLOR_GRAY = '#AAAFB5';
const COLOR_GRAY_LIGHT = '#E5E5E5';
const COLOR_GRAY_DARK = '#6A6A6A';

export default class extends Controller {
  static targets = ['canvas'];
  static values = { data: Object, url: String };

  initialize() {
    Chart.defaults.color = '#000';
  }

  disconnect() {
    this.chart.destroy();

    document.removeEventListener(
      'amba:theme_changed',
      this.reInitializeOnColorChange
    );
  }

  connect() {
    document.addEventListener(
      'amba:theme_changed',
      this.reInitializeOnColorChange
    );
    this.initializeChart();
  }

  reInitializeOnColorChange = () => {
    this.chart.destroy();
    this.initializeChart();
  };

  initializeChart() {
    this.chart = new Chart(this.canvasTarget, {
      type: 'bar',
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: (context) =>
                t('js.charts.sleep_durations.vip_count', {
                  count: context.parsed.x,
                }),
            },
          },
        },
        indexAxis: 'y',
        scales: {
          x: {
            steps: 1,
            beginAtZero: true,
            stacked: true,
            grid: {
              display: true,
              color: this.gridColor,
              borderColor: this.gridColor,
            },
            title: {
              display: true,
              text: t('js.charts.sleep_durations.no_of_vips'),
              color: this.chartLabelColor,
            },
            ticks: {
              precision: 0,
              color: this.chartLabelColor,
            },
          },
          y: {
            ticks: {
              precision: 0,
              color: this.chartLabelColor,
            },
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: t('js.charts.sleep_durations.sleep_duration'),
              color: this.chartLabelColor,
            },
          },
        },
      },
      data: {
        labels: this.labels,
        datasets: [
          {
            label: {
              display: false,
            },
            backgroundColor: '#08cff7',
            order: 3,
            datalabels: {
              display: false,
            },
            data: this.chartData,
          },
        ],
      },
    });
  }

  get labels() {
    return Object.values(this.dataValue)
      .map((period) => period.label)
      .reverse();
  }

  get chartData() {
    return Object.values(this.dataValue)
      .map((period) => period.data.length)
      .reverse();
  }

  get legendLabelColor() {
    return currentTheme() === 'light' ? COLOR_BLACK : COLOR_GRAY;
  }

  get chartLabelColor() {
    return currentTheme() === 'light' ? COLOR_GRAY_DARK : COLOR_GRAY;
  }

  get gridColor() {
    return currentTheme() === 'light' ? COLOR_GRAY_LIGHT : COLOR_GRAY_DARK;
  }
}
